export interface CatalogEntry {
  name: string;
  title: string;
  createdAt: string;
}

export type CatalogOrder =
  | "popular"
  | "newest"
  | "oldest"
  | "title-asc"
  | "title-desc";

export function sortCatalog<T extends CatalogEntry>(
  items: readonly T[],
  order: CatalogOrder = "newest",
  popularityScores: Readonly<Record<string, number>> = {}
): T[] {
  return [...items].sort((a, b) => {
    const titleOrder = a.title.localeCompare(b.title, "en");
    if (order === "title-asc") return titleOrder;
    if (order === "title-desc") return -titleOrder;
    if (order === "popular") {
      const popularityOrder =
        (popularityScores[b.name] ?? 0) - (popularityScores[a.name] ?? 0);
      if (popularityOrder) return popularityOrder;
    }
    const dateOrder = a.createdAt.localeCompare(b.createdAt);
    return (order === "oldest" ? dateOrder : -dateOrder) || titleOrder;
  });
}
